import styled from 'styled-components'

import { FemiButton } from '../FemiButton'

export const StyledFemiSubscriptions = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
  SecondaryAction: styled.p`
    margin-top: 16px;
  `,
  ActionButton: styled(FemiButton)`
    & + & {
      margin-top: 12px;
    }
  `,
}
